/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/aria-proptypes */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { head, get, last } from 'lodash';
import moment from 'moment';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import chapsPaymentContent, { contentPropTypes } from './chapsPayment.content';
import { invalidBatchNameCharactersRegex, chapsReferenceMaxLength, TYPE_CHAPS } from '../../../config';
import {
	getChapsPaymentsList,
	getPaymentsHaveFromAndToAccount,
	// isNumberOfPaymentsLimit,
	isBatchEligible,
	getPaymentsTotal,
	getPaymentIdsforSameReference,
	getPaymentIdsforSameDate,
	getAnyPaymentToBillerOrCreditCard,
	isAnyFutureDatedPaymentUnsupported,
	getFirstPaymentIsFutureDated,
	canApplySameForAll,
	isMultiplePayments,
	hasTransactionLimitError,
	getIsEditing,
	getToAccount,
} from '../../../states/chaps/selectors';
import { goToPage, pages, goBackPage, goToPreviousPage, setBackPage } from '../../../states/page/actions';
import { chapsCopyRefToAll, chapsCopyDateToAll, chapsUpdatePaymentDetails } from '../../../states/chaps/actions';
import { hasApiCallInProgress } from '../../../states/api/selectors';

import { formValid } from '../../../states/validation/selectors';
import paymentPropTypes from '../../../states/payments/propTypes';
import { addPayment, handlePayeeSrdCheck, handlePaymentsContinue } from '../../../states/payments/actions';
import { getAccountsWithChapsCapability } from '../../../states/accounts/selectors';
import { getPayees, hasRefChangedFromDefault } from '../../../states/payees/selectors';
import {
	getCurrentTemplateId,
	getTemplateName,
	getIsVersionConflict,
	getTemplateLastUpdatedBy,
	getTemplateLastUpdatedTime,
	getIsTemplateMode,
} from '../../../states/templates/selectors';
import {
	hasPaymentCapability,
	isAuthorisationEdit,
	isMultiTransactions,
	isManagePaymentEdit,
} from '../../../states/modes/selectors';
import { getSubmissionDates } from '../../../states/calendar/selectors';
import { toggleBatch, updateBatchName } from '../../../states/batch/actions';
import { isBatch, getBatchId, getBatchName, getBatchTotalLimitExceeded } from '../../../states/batch/selectors';
import { showAllErrors, initValidationForTemplate } from '../../../states/validation/actions';
import accountPropTypes, { fromAccountPropType, toAccountPropType } from '../../../states/accounts/propTypes';
import payeePropTypes from '../../../states/payees/propTypes';
import PaymentListLayout from '../../../sharedComponents/PaymentListLayout';
import PaymentHeader from '../../../fasterPayments/components/Payments/PaymentHeader';
import PageNavigation from '../../../sharedComponents/PageNavigation/PageNavigation';
import Notifications from '../../../sharedComponents/Notifications';
import ChapsPayment from './ChapsPayment';
import TemplateButtons from '../../../sharedComponents/TemplateButtons/TemplateButtons';
import {
	savePaymentsAsTemplateAndNotify,
	savePaymentsAsTemplateAndExit,
	savePaymentsAsTemplateAndMakePayment,
	removeTemplateNameValidation,
	addTemplateNameValidation,
	overWriteTemplate,
	submitDeleteTemplate,
} from '../../../states/templates/actions';
import SaveAsTemplateToggle from '../../../sharedComponents/SaveAsTemplateToggle/SaveAsTemplateToggle';
import UnSavedWarningModal from '../../../sharedComponents/UnSavedWarningModal/UnSavedWarningModal';
import { cleanIllegalHVPMCharacters, hasAllRequiredCopFields } from '../../../helpers/fieldHelpers';
import { setSelectedFromAccount, setSelectedPaymentId } from '../../../states/payeeSelector/actions';
import { goToEditPayeePage } from '../../../states/api/fasterPaymentActions';
import withMissingDetails from '../../../containers/withMissingDetails';
import { COPCheck } from '../../../sharedComponents/COPCheck/COPCheck';
import { getPayeeById } from '../../../states/commonSelectors/selectors';
import { getPayeeSrdCheck } from '../../../states/payees/actions';
import { updateBeneficiary } from '../../../cop/states/actions';
import { getCopResult } from '../../../cop/states/selectors';
import { setSelectedPayee } from '../../../managePayee/states/action';
import { setCanAddMultiplePayees } from '../../../states/modes/actions';
import { getPage } from '../../../states/page/selectors';

export const cleanBatchName = (batchName) => batchName.replace(invalidBatchNameCharactersRegex, '');

const mapState = (state) => ({
	hasApiCallInProgress: hasApiCallInProgress(state),
	payments: getChapsPaymentsList(state),
	toAccounts: [],
	fromAccounts: getAccountsWithChapsCapability(state),
	toPayees: getPayees(state),
	paymentsHaveFromAndToAccount: getPaymentsHaveFromAndToAccount(state),
	hasPaymentCapability: hasPaymentCapability(state),
	isBatch: isBatch(state),
	isBatchEligible: isBatchEligible(state),
	batchId: getBatchId(state),
	batchName: getBatchName(state),
	paymentsTotal: getPaymentsTotal(state),
	isFormValid: formValid(state),
	paymentIdsForSameReference: getPaymentIdsforSameReference(state),
	getPaymentIdsforSameDate: getPaymentIdsforSameDate(state),
	isAnyPaymentToCreditCardOrBiller: getAnyPaymentToBillerOrCreditCard(state),
	isAnyFutureDatedPaymentUnsupported: isAnyFutureDatedPaymentUnsupported(state),
	isFirstPaymentFutureDated: getFirstPaymentIsFutureDated(state),
	isAuthorisationEdit: isAuthorisationEdit(state),
	allowApplySameForAll: canApplySameForAll(state),
	isMultiTransactions: isMultiTransactions(state),
	isManagePaymentEdit: isManagePaymentEdit(state),
	isBatchLimitExceeded: getBatchTotalLimitExceeded(state),
	templateId: getCurrentTemplateId(state),
	templateName: getTemplateName(state),
	isMultiplePayments: isMultiplePayments(state),
	isLongRef: true,
	referenceMaxLength: chapsReferenceMaxLength,
	isEditing: getIsEditing(state),
	templateMode: getIsTemplateMode(state),
	isVersionConflict: getIsVersionConflict(state),
	templateLastUpdatedBy: getTemplateLastUpdatedBy(state),
	templateLastUpdatedTime: getTemplateLastUpdatedTime(state),
	submissionDates: getSubmissionDates(state),
	isRefUpdated: (toAccount, reference) => hasRefChangedFromDefault(state, toAccount, reference),
	getPayeeById: (id) => getPayeeById(state, id),
	copResult: getCopResult(state),
	getPayees: () => getPayees(state),
	currentPage: getPage(state),
	toAccount: getToAccount(state),
});

const mapDispatch = (dispatch, props) => ({
	handleToggleIsBatch: (isBatch) => dispatch(toggleBatch(isBatch)),
	addPayment: () => dispatch(addPayment()),
	handleBatchNameChanged: (event) =>
		dispatch(
			updateBatchName({
				name: cleanBatchName(event.target.value),
			})
		),
	copyRefToAllAction: (paymentIdsForSameReference, reference) =>
		dispatch(chapsCopyRefToAll(paymentIdsForSameReference, reference)),
	copyDateToAllAction: (getPaymentIdsforSameDate, date) => dispatch(chapsCopyDateToAll(getPaymentIdsforSameDate, date)),
	showAllErrors: () => dispatch(showAllErrors()),
	continueToPayeeSelector: () => dispatch(goToPage(pages.ChapsPayeeSelector)),
	handleUpdateChapsPayment: (payment) => dispatch(chapsUpdatePaymentDetails(payment)),
	initValidationForTemplate: () => dispatch(initValidationForTemplate()),
	handleSaveTemplate: () => dispatch(savePaymentsAsTemplateAndNotify(TYPE_CHAPS)),
	handleSaveTemplateAndExit: () => {
		dispatch(savePaymentsAsTemplateAndExit(TYPE_CHAPS));
	},
	handleSaveTemplateAndMakePayment: () => dispatch(savePaymentsAsTemplateAndMakePayment(TYPE_CHAPS)),
	removeTemplateNameValidation: () => dispatch(removeTemplateNameValidation()),
	addTemplateNameValidation: () => dispatch(addTemplateNameValidation()),
	handleBack: () => dispatch(goBackPage()),
	handleOverwriteTemplate: () => dispatch(overWriteTemplate(TYPE_CHAPS)),
	handleDeleteTemplate: () => dispatch(submitDeleteTemplate()),
	setSelectedFromAccount: (fromAccount) => dispatch(setSelectedFromAccount(fromAccount)),
	setSelectedPaymentId: (paymentId) => dispatch(setSelectedPaymentId(paymentId)),
	getPayeeSrdCheck: (sortCodeAccountNumber) => dispatch(getPayeeSrdCheck(sortCodeAccountNumber)),
	updateBeneficiary: ({ sourceAccountId, payeeDetails, copResult }) =>
		dispatch(updateBeneficiary({ id: props.id, sourceAccountId, payeeDetails, copResult })),
	handlePaymentsContinue: ({ saveAsTemplate, setShowErrors, handleSaveTemplate }) =>
		dispatch(
			handlePaymentsContinue({
				handleSaveTemplate,
				handleContinue: props.handleContinue,
				saveAsTemplate,
				setShowErrors,
			})
		),
	handlePayeeSrdCheck: ({
		handleEditPayee,
		handleSaveTemplate,
		saveAsTemplate,
		sortCodeAccountNumber,
		setCopCheckRequired,
		setShowErrors,
		payeeReference,
	}) =>
		dispatch(
			handlePayeeSrdCheck({
				sortCodeAccountNumber,
				setCopCheckRequired,
				handleEditPayee,
				handleSaveTemplate,
				handleContinue: props.handleContinue,
				saveAsTemplate,
				setShowErrors,
				payeeReference,
			})
		),
	setSelectedPayee: (selectedPayee) => dispatch(setSelectedPayee(selectedPayee)),
	goToPreviousPage: () => dispatch(goToPreviousPage()),
	setCanAddMultiplePayees: (canAddMultiplePayees) => dispatch(setCanAddMultiplePayees(canAddMultiplePayees)),
	goToEditPayeePage: (isCOPEdit) => dispatch(goToEditPayeePage(isCOPEdit)),
	setBackPage: (page) => {
		dispatch(setBackPage(page));
	},
});

class ChapsPaymentList extends Component {
	constructor(props) {
		super(props);

		this.copyFirstRefToAll = this.copyFirstRefToAll.bind(this);
		this.copyFirstDateToAll = this.copyFirstDateToAll.bind(this);
		this.handleTypeTooltip = this.handleTypeTooltip.bind(this);
		this.handleReferenceTooltip = this.handleReferenceTooltip.bind(this);
		this.updateActiveRow = this.updateActiveRow.bind(this);
		this.handleSameRef = this.handleSameRef.bind(this);
		this.handleSameDate = this.handleSameDate.bind(this);
		this.copyRefToAll = this.copyRefToAll.bind(this);
		this.copyDateToAll = this.copyDateToAll.bind(this);
		this.continueToPayeeSelector = this.continueToPayeeSelector.bind(this);
		this.handleContinue = this.handleContinue.bind(this);
		this.handleSaveAsTemplateToggle = this.handleSaveAsTemplateToggle.bind(this);
		this.handleBack = this.handleBack.bind(this);
		this.handleAddMore = this.handleAddMore.bind(this);
		this.handleCOPCancel = this.handleCOPCancel.bind(this);
		this.handleCOPEdit = this.handleCOPEdit.bind(this);
		this.handleCOPSuccess = this.handleCOPSuccess.bind(this);
		this.setCopCheckRequired = this.setCopCheckRequired.bind(this);
		this.setShowErrors = this.setShowErrors.bind(this);

		this.state = {
			typeTooltipHelpOpen: false,
			refTooltipHelpOpen: false,
			showSameRefPopover: false,
			showSameDatePopover: false,
			activeRowId: '',
			showErrors: props.showErrors || false,
			saveAsTemplate: false,
			isCOPCheckRequired: false,
		};
	}

	componentWillMount() {
		const { templateMode, initValidationForTemplate } = this.props;
		if (templateMode) {
			initValidationForTemplate();
		}
	}

	componentDidMount() {
		const { handleDisplayFullwidth = () => {} } = this.props;
		handleDisplayFullwidth();
	}

	copyFirstRefToAll() {
		const { isAnyPaymentToCreditCardOrBiller, paymentIdsForSameReference, copyRefToAllAction, payments } = this.props;
		const { reference } = head(payments);

		copyRefToAllAction(paymentIdsForSameReference, reference);

		if (isAnyPaymentToCreditCardOrBiller) {
			this.setState({ showSameRefPopover: true });
		}
	}

	copyFirstDateToAll() {
		const {
			isAnyFutureDatedPaymentUnsupported,
			isFirstPaymentFutureDated,
			getPaymentIdsforSameDate,
			copyDateToAllAction,
			payments,
		} = this.props;

		const { date } = head(payments);
		copyDateToAllAction(getPaymentIdsforSameDate, date);

		if (isFirstPaymentFutureDated && isAnyFutureDatedPaymentUnsupported) {
			this.setState({ showSameDatePopover: true });
		}
	}

	copyRefToAll(reference) {
		const { isAnyPaymentToCreditCardOrBiller, paymentIdsForSameReference, copyRefToAllAction } = this.props;

		copyRefToAllAction(paymentIdsForSameReference, reference);

		if (isAnyPaymentToCreditCardOrBiller) {
			this.setState({ showSameRefPopover: true });
		}
	}

	copyDateToAll(date) {
		const {
			isAnyFutureDatedPaymentUnsupported,
			isFirstPaymentFutureDated,
			getPaymentIdsforSameDate,
			copyDateToAllAction,
		} = this.props;

		copyDateToAllAction(getPaymentIdsforSameDate, date);

		if (isFirstPaymentFutureDated && isAnyFutureDatedPaymentUnsupported) {
			this.setState({ showSameDatePopover: true });
		}
	}

	handleTypeTooltip(event) {
		event.preventDefault();
		this.setState({ typeTooltipHelpOpen: !this.state.typeTooltipHelpOpen });
	}

	handleReferenceTooltip(event) {
		event.preventDefault();
		this.setState({ refTooltipHelpOpen: !this.state.refTooltipHelpOpen });
	}

	updateActiveRow(id) {
		this.setState({ activeRowId: id });
	}

	handleSameRef(event) {
		event.preventDefault();
		this.setState({ showSameRefPopover: false });
	}

	handleSameDate(event) {
		event.preventDefault();
		this.setState({ showSameDatePopover: false });
	}

	continueToPayeeSelector(paymentId) {
		const { continueToPayeeSelector, setSelectedPaymentId, setSelectedFromAccount, payments, setCanAddMultiplePayees } =
			this.props;
		const { fromAccount } = payments.find((payment) => payment.id === paymentId);

		setCanAddMultiplePayees(false);
		setSelectedPaymentId(paymentId);
		setSelectedFromAccount(fromAccount);
		continueToPayeeSelector();
	}

	handleContinue() {
		const {
			isFormValid,
			showAllErrors,
			payments,
			isRefUpdated,
			getPayeeById,
			isMultiplePayments,
			handlePaymentsContinue,
			handlePayeeSrdCheck,
			handleSaveTemplate,
			setSelectedPayee,
			isManagePaymentEdit,
		} = this.props;
		showAllErrors();
		// Try to use `chapsReference` if it exists first, before trying the `reference` key.
		const firstPaymentRef = payments[0]?.chapsReference ? payments[0].chapsReference : payments[0]?.reference;
		if (isFormValid) {
			if (isManagePaymentEdit || isMultiplePayments || !isRefUpdated(payments[0]?.toAccount, firstPaymentRef)) {
				handlePaymentsContinue({
					saveAsTemplate: this.state.saveAsTemplate,
					setShowErrors: this.setShowErrors,
					handleSaveTemplate,
				});
			} else {
				const targetPayee = getPayeeById(payments[0].toAccount);
				const payeeReference = targetPayee.reference;
				setSelectedPayee(targetPayee);
				const {
					to_account: { account_number, sort_code },
				} = targetPayee;
				const sortCodeAccountNumber = sort_code.concat(account_number);
				handlePayeeSrdCheck({
					handleSaveTemplate,
					sortCodeAccountNumber,
					setCopCheckRequired: this.setCopCheckRequired,
					saveAsTemplate: this.state.saveAsTemplate,
					setShowErrors: this.setShowErrors,
					payeeReference,
				});
			}
		} else {
			this.setState({ showErrors: true });
		}
	}

	handleSaveAsTemplateToggle() {
		const { removeTemplateNameValidation, addTemplateNameValidation } = this.props;
		if (!this.state.saveAsTemplate) {
			this.setState({ saveAsTemplate: true });
			addTemplateNameValidation();
		} else {
			this.setState({ saveAsTemplate: false });
			removeTemplateNameValidation();
		}
	}

	setCopCheckRequired() {
		this.setState({ isCOPCheckRequired: true });
	}

	setShowErrors() {
		this.setState({ showErrors: true });
	}

	SaveTemplate(saveTemplateHandler) {
		const { isFormValid, showAllErrors } = this.props;
		showAllErrors();
		if (!isFormValid) return this.setState({ showErrors: true });

		return saveTemplateHandler();
	}

	handleBack() {
		const { handleBackParent, templateMode, handleBack } = this.props;
		const { unfinishedTemplateModalOpen } = this.state;

		if (unfinishedTemplateModalOpen) {
			this.setState({ unfinishedTemplateModalOpen: false }, handleBack);
			return;
		}

		if (templateMode) {
			this.setState({ unfinishedTemplateModalOpen: true });
			return;
		}

		handleBackParent();
	}

	handleAddMore() {
		const { continueToPayeeSelector, setSelectedFromAccount, payments, setCanAddMultiplePayees, setSelectedPaymentId } =
			this.props;
		const fromAccount = get(last(payments), 'fromAccount', '');

		setCanAddMultiplePayees(true);
		setSelectedPaymentId(null);
		setSelectedFromAccount(fromAccount);
		continueToPayeeSelector();
	}

	/**
	 * As per discussion with business held on 08/04 -
	 * do not trigger beneficiary recreation flow for the CHAPS SRD payees.
	 */
	handleCOPSuccess() {
		const { handleContinue, handlePaymentsContinue, handleSaveTemplate, payments, setSelectedPaymentId } = this.props;
		const { saveAsTemplate } = this.state;

		const paymentId = get(payments, '[0].id');
		setSelectedPaymentId(paymentId);

		if (saveAsTemplate) {
			handlePaymentsContinue({
				handleSaveTemplate,
				saveAsTemplate,
				setShowErrors: this.setShowErrors,
			});
		} else {
			handleContinue();
		}
	}

	handleCOPCancel() {
		this.setState({ isCOPCheckRequired: false });
	}

	handleCOPEdit(selectedPayeeId) {
		const { getPayeeById, setSelectedPayee, goToEditPayeePage, currentPage, setBackPage } = this.props;
		setSelectedPayee(getPayeeById(selectedPayeeId));
		setBackPage(currentPage);
		goToEditPayeePage(true);
	}

	render() {
		const {
			payments,
			isMultiplePayments,
			hasPaymentCapability,
			content,
			copCheckTriggered,
			isBatch,
			batchName,
			isAuthorisationEdit,
			hasApiCallInProgress,
			templateMode,
			isManagePaymentEdit,
			templateId,
			isLongRef,
			referenceMaxLength,
			isEditing,
			handleSaveTemplate,
			handleSaveTemplateAndExit,
			handleSaveTemplateAndMakePayment,
			isVersionConflict,
			handleOverwriteTemplate,
			handleBack: cancelOverwrite,
			templateLastUpdatedBy,
			templateLastUpdatedTime,
			handleDeleteTemplate,
			sessionCOPChecks,
			submissionDates,
			toAccount,
		} = this.props;

		const { unfinishedTemplateModalOpen, isCOPCheckRequired } = this.state;

		const showBackButton =
			(!payments.some((payment) => payment.toAccount) && isMultiTransactions) ||
			isAuthorisationEdit ||
			templateMode ||
			isManagePaymentEdit ||
			isEditing;

		const isPaymentEdit = !isBatch && isAuthorisationEdit;
		const { saveTemplateButtonText, saveTemplateAndMakePaymentButtonText, saveTemplateAndExitButtonText } = content;
		const showSaveAsTemplateToggle = !isManagePaymentEdit && !templateMode && !templateId;
		const showOverwriteModal = templateMode && templateId && isVersionConflict;

		if (isCOPCheckRequired) {
			return (
				<COPCheck
					copCheckTriggered={copCheckTriggered}
					handleComplete={this.handleCOPSuccess}
					handleCancel={this.handleCOPCancel}
					handleEdit={this.handleCOPEdit}
					payeeId={payments[0].toAccount}
					reference={payments[0].reference}
					sessionCOPChecks={sessionCOPChecks}
				/>
			);
		}

		return (
			<div
				ref={(wrapper) => {
					this.wrapper = wrapper;
				}}
			>
				{templateMode && (
					<UnSavedWarningModal
						handleClose={() => {
							this.setState({ unfinishedTemplateModalOpen: false });
						}}
						isModalOpen={unfinishedTemplateModalOpen}
						handleBack={this.handleBack}
						contentKey={templateId ? 'editTemplateContent' : 'newTemplateContent'}
					/>
				)}

				{showOverwriteModal && (
					<UnSavedWarningModal
						handleClose={cancelOverwrite}
						isModalOpen
						handleBack={handleOverwriteTemplate}
						contentKey="overwriteTemplateContent"
						user={templateLastUpdatedBy}
						dateTime={templateLastUpdatedTime}
					/>
				)}

				{showBackButton && <BackButton onClick={this.handleBack} disabled={hasApiCallInProgress} />}

				<PaymentHeader
					hasPaymentCapability={hasPaymentCapability}
					showSubHeader={!isMultiplePayments && !isAuthorisationEdit}
					content={content}
					isBatchEdit={isBatch && (isAuthorisationEdit || isEditing)}
					isPaymentEdit={isPaymentEdit || isManagePaymentEdit}
					batchName={batchName}
					templateMode={templateMode}
					isEditingTemplate={templateMode && !!templateId}
					templateId={templateId}
					chapsMode
				/>

				<div className="u-margin-bottom-2">
					<Notifications />
				</div>
				<PaymentListLayout
					{...{ ...this.props, ...this.state }}
					copyFirstRefToAll={this.copyFirstRefToAll}
					copyFirstDateToAll={this.copyFirstDateToAll}
					copyRefToAll={this.copyRefToAll}
					copyDateToAll={this.copyDateToAll}
					handleTypeTooltip={this.handleTypeTooltip}
					handleReferenceTooltip={this.handleReferenceTooltip}
					updateActiveRow={this.updateActiveRow}
					handleSameRef={this.handleSameRef}
					handleSameDate={this.handleSameDate}
					progressiveReveal={false}
					showToPayeeList={false}
					handleToCardClick={this.continueToPayeeSelector}
					chapsMode
					PaymentComponent={ChapsPayment}
					isLongRef={isLongRef}
					referenceMaxLength={referenceMaxLength}
					showAddNewPaymentButton={!isEditing || (isEditing && isBatch)}
					hasTransactionLimitError={hasTransactionLimitError}
					templateMode={templateMode}
					handleDeleteTemplate={handleDeleteTemplate}
					isChapsEditing={isEditing}
					paymentDates={submissionDates}
					cleanIllegalCharacters={cleanIllegalHVPMCharacters}
					handleAddMore={this.handleAddMore}
					isPaymentEdit={isPaymentEdit || isManagePaymentEdit}
					toAccount={toAccount}
				/>

				{showSaveAsTemplateToggle && (
					<SaveAsTemplateToggle isChecked={this.state.saveAsTemplate} handleToggle={this.handleSaveAsTemplateToggle} />
				)}

				<PageNavigation
					showLoading={hasApiCallInProgress}
					handleContinue={this.handleContinue}
					showContinue={!templateMode}
					enableContinue={!hasApiCallInProgress}
				>
					{templateMode && (
						<TemplateButtons
							saveTemplate={() => this.SaveTemplate(handleSaveTemplate)}
							saveTemplateAndExit={() => this.SaveTemplate(handleSaveTemplateAndExit)}
							saveTemplateAndMakePayment={() => this.SaveTemplate(handleSaveTemplateAndMakePayment)}
							isLoading={hasApiCallInProgress}
							saveTemplateButtonText={saveTemplateButtonText}
							saveTemplateAndMakePaymentButtonText={saveTemplateAndMakePaymentButtonText}
							saveTemplateAndExitButtonText={saveTemplateAndExitButtonText}
							showTemplateButtons
						/>
					)}
					{this.state.saveAsTemplate && (
						<Button
							isLoading={hasApiCallInProgress}
							id="button-save-as-template-exit"
							display="secondary"
							onClick={() => this.SaveTemplate(handleSaveTemplateAndExit)}
							disabled={hasApiCallInProgress}
						>
							{saveTemplateAndExitButtonText}
						</Button>
					)}
				</PageNavigation>
			</div>
		);
	}
}

ChapsPaymentList.propTypes = {
	payments: PropTypes.arrayOf(PropTypes.shape(paymentPropTypes)).isRequired,
	addPayment: PropTypes.func.isRequired,
	isMultiplePayments: PropTypes.bool,
	paymentsHaveFromAndToAccount: PropTypes.bool.isRequired,
	hasPaymentCapability: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	frequencyLabel: PropTypes.string,
	firstPaymentLabel: PropTypes.string,
	stopPaymentLabel: PropTypes.string,
	stopOnNumberLabel: PropTypes.string,
	stopOnDateLabel: PropTypes.string,
	isBatch: PropTypes.bool,
	batchName: PropTypes.string,
	handleToggleIsBatch: PropTypes.func,
	handleBatchNameChanged: PropTypes.func,
	isBatchEligible: PropTypes.bool.isRequired,
	showAllErrors: PropTypes.func.isRequired,
	isFormValid: PropTypes.bool.isRequired,
	paymentIdsForSameReference: PropTypes.arrayOf(PropTypes.string),
	getPaymentIdsforSameDate: PropTypes.arrayOf(PropTypes.string),
	isAnyPaymentToCreditCardOrBiller: PropTypes.bool,
	isAnyFutureDatedPaymentUnsupported: PropTypes.bool,
	isFirstPaymentFutureDated: PropTypes.bool,
	isAuthorisationEdit: PropTypes.bool.isRequired,
	bankId: PropTypes.string.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	copyRefToAllAction: PropTypes.func.isRequired,
	copyDateToAllAction: PropTypes.func.isRequired,
	batchId: PropTypes.string,
	toAccounts: PropTypes.arrayOf(PropTypes.shape(toAccountPropType)).isRequired,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)).isRequired,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	allowApplySameForAll: PropTypes.bool.isRequired,
	isMultiTransactions: PropTypes.bool.isRequired,
	isBatchLimitExceeded: PropTypes.bool,
	showValidation: PropTypes.bool,
	handleToCardClick: PropTypes.func,
	handleFromCardClick: PropTypes.func,
	templateMode: PropTypes.bool,
	updateValidation: PropTypes.func,
	validations: PropTypes.shape({}),
	hideErrorMsg: PropTypes.func,
	handleDeleteTemplate: PropTypes.func,
	templateId: PropTypes.string,
	templateName: PropTypes.string,
	isManagePaymentEdit: PropTypes.bool.isRequired,
	handleAddMore: PropTypes.func,
	continueToPayeeSelector: PropTypes.func.isRequired,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	handleContinue: PropTypes.func.isRequired,
	showErrors: PropTypes.bool,
	isLongRef: PropTypes.bool,
	referenceMaxLength: PropTypes.string,
	hasTransactionLimitError: PropTypes.func,
	chapsMode: PropTypes.string,
	handleUpdateChapsPayment: PropTypes.func,
	isEditing: PropTypes.bool,
	handleBackParent: PropTypes.func,
	initValidationForTemplate: PropTypes.func.isRequired,
	handleSaveTemplate: PropTypes.func,
	handleSaveTemplateAndExit: PropTypes.func,
	handleSaveTemplateAndMakePayment: PropTypes.func,
	removeTemplateNameValidation: PropTypes.func.isRequired,
	addTemplateNameValidation: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	isVersionConflict: PropTypes.bool,
	templateLastUpdatedBy: PropTypes.string,
	templateLastUpdatedTime: PropTypes.string,
	handleOverwriteTemplate: PropTypes.func,
	handleDisplayFullwidth: PropTypes.func,
	submissionDates: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
	cleanIllegalCharacters: PropTypes.func,
	setSelectedFromAccount: PropTypes.func.isRequired,
	setSelectedPaymentId: PropTypes.func.isRequired,
	goToPreviousPage: PropTypes.func.isRequired,
	goToEditPayeePage: PropTypes.func.isRequired,
	setBackPage: PropTypes.func.isRequired,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
};

export default compose(
	connect(mapState, mapDispatch),
	withContent({ content: chapsPaymentContent }),
	withScrollTop,
	withMissingDetails
)(ChapsPaymentList);
